export default __webpack_public_path__ + "static/media/creditcard-plus-tilted-trademark.9536924e.svg";